import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import moment from 'moment/moment';
import { Spinner } from '@ps-design-system/components/Spinner';
import { Text } from '@ps-design-system/components/Text';
import { SyncStatus } from '../../util/syncStatus';
import { Button } from '@ps-design-system/components/Button';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import LastUpdatedStrings, { getRefreshLabel } from './strings';

const LastUpdated = ({ intl }) => {
  const syncStatus = useCalendarStore(state => state.syncStatus);
  const { synced_last } = useCalendarStore(state => state.syncedCalendarData || {});
  const { resyncCalendar } = useCalendarStore();

  return (
    <div className="LastUpdated">
      <Text typeface="caption-1" className="LastUpdated_label">
        {getRefreshLabel(moment(synced_last).locale(intl.locale).fromNow())}
      </Text>
      {syncStatus === SyncStatus.SYNCING &&
        <Spinner appearance="black" className="LastUpdated_spinner"/>
      }
      {syncStatus !== SyncStatus.SYNCING &&
        <Button
          onClick={resyncCalendar}
          variant="underline"
          className="LastUpdated_refresh-button"
        >
          <Text typeface="caption-1">
            {LastUpdatedStrings.refreshButton}
          </Text>
        </Button>
      }
    </div>
  );
};

LastUpdated.propTypes = {
  intl: PropTypes.object.isRequired
};

export default injectIntl(LastUpdated);
